import useId from '../utils/useId';
import * as React from 'react';
export const fcbtSvg = React.forwardRef(function fcbtSvgInner(props, ref) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          x1: '50%',
          y1: '0%',
          x2: '50%',
          y2: '100%',
          id: `bi_fcbt__a_${id_0}`,
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#0F4494',
          offset: '0%',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#002D72',
          offset: '100%',
        }),
      ),
    ),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: `url(#bi_fcbt__a_${id_0})`,
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M17.393 11.985c-1.567.57-1.343 1.283-1.343 1.235v1.568s0-.427 1.12-.855h.074l7.787-3.255v3.469l-8.086 3.397c-.97.357-1.045 1.355-1.045 1.355v1.64c0 1.14-1.268 1.567-1.268 1.567l-4.155 1.782v1.568l-3.558 1.426V16.38l7.638-3.089s1.493-.499 1.493-1.568v-1.64s-.224-1.068 1.269-1.639L25.03 5.19v3.54l-7.638 3.256zM15.9 17.307V15.81c-.149.57-.97.784-.97.784l-4.453 1.853v1.925l4.453-1.853s.97-.428.97-1.212z',
        fill: '#FFF',
      }),
    ),
  );
});
fcbtSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var fcbt = {
  category: 'brand',
  colorable: false,
  name: 'fcbt',
  svg: fcbtSvg,
};
